import { Tabs } from "@exopengithub/exokit";
import { TabLink } from "components/tabs/TabLink";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { AI_PRODUCT_NAME } from "src/common/branding.js";
import { HeaderLayout } from "src/routes/HeaderLayout.js";
import { useAiChatAccess } from "src/features/ai-chat/hooks/useAiChatAccess.js";
import { useProductAccess } from "src/features/products/useProductAccess.js";
import { getProduct } from "src/features/products/products.js";
import { useLoadedCompanyDomain } from "src/routes/routeDataHooks.js";

export const SettingsPage = () => {
	const { t } = useTranslation();
	const companyDomain = useLoadedCompanyDomain();
	const { hasAccess, optedIn } = useAiChatAccess(companyDomain.id);
	const hasAiChatAccess = hasAccess && optedIn;
	const { access } = useProductAccess();

	return (
		<HeaderLayout
			title={t("Settings")}
			tabs={
				<Tabs>
					<TabLink to="." end>
						{t("General")}
					</TabLink>
					<TabLink to="users">{t("Users")}</TabLink>
					<TabLink to="terms-and-policies">{t("Terms and Policies")}</TabLink>
					<TabLink to="api-keys">{t("API keys")}</TabLink>
					{hasAiChatAccess && <TabLink to="ai-chat">{AI_PRODUCT_NAME}</TabLink>}
					{access.planning.active && (
						<TabLink to="planning">{getProduct("planning").name}</TabLink>
					)}
				</Tabs>
			}
		>
			<Outlet />
		</HeaderLayout>
	);
};
